import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
 changeIsMainMenuOpened, changeLanguage, saveConfiguration, setPopupState,
} from '../../model/configuratorSlice';
import { CloseButton } from '../../shared/svg/components';
import SaveConfigurationService from '../../services/SaveConfigurationService';
import { Language, PopupState } from '../../model/constants';
import IsNullOrUndefined from '../../utils/ObjectUtils';
import { TranslationUtility } from '../../utilities/TranslationUtility';
import IsNullOrEmpty from '../../utils/StringUtils';

const MainMenu = () => {
  const {
     promotionSlug, isMainMenuOpened, user, currentUnit, currentLanguage, translations,
    } = useSelector(state => state.configurator);
  const saveConfigurationMutation = SaveConfigurationService();
  const dispatch = useDispatch();

  const isUserLoggedIn = () => user !== null && user.isLoggedIn;

  const areTranslationsEnabled = () => !IsNullOrEmpty(translations);

  const isLanguageEnabled = (language) => {
      if (!IsNullOrEmpty(translations)) {
          const foundLanguage = translations.find(t => t.language === language);
          if (!IsNullOrUndefined(foundLanguage)) return true;
      }
      return false;
  };

  return (
    <div className={`main-menu ${isMainMenuOpened ? 'opened' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <button
        className={`background ${isMainMenuOpened ? 'opened' : ''}`}
        type="button"
        onClick={() => dispatch(changeIsMainMenuOpened(false))}
      />
      <div className={`panel ${isMainMenuOpened ? 'opened' : ''}`}>
        <button
          type="button"
          className="close-button"
          onClick={() => dispatch(changeIsMainMenuOpened(false))}
        >
          <CloseButton />
        </button>
        <div className="main-menu-content">
          {/* <img
            src={`${process.env.PUBLIC_URL}/promotion/${promotionSlug}.png`}
            alt=""
          /> */}
          {isUserLoggedIn()
                    ? <div className="flat-name">{currentUnit !== null ? currentUnit.name : ''}</div> : null}
          <div className="account-container">
            {!isUserLoggedIn() ? (
              <>
                <button
                  className="menu-button-login"
                  type="button"
                  onClick={() => {
                                        dispatch(changeIsMainMenuOpened(false));
                                        dispatch(setPopupState(PopupState.Login));
                                    }}
                >Iniciar sesión
                </button>
              </>
                        )
                        : (
                          <>
                            <button
                              className="menu-button-login"
                              type="button"
                              onClick={() => {
                                        dispatch(changeIsMainMenuOpened(false));
                                        dispatch(setPopupState(PopupState.Logout));
                                    }}
                            >
                              {TranslationUtility.GetFormattedMessageForUI('ui-button-logout', 'Cerrar Sesión')}
                            </button>
                            {!IsNullOrUndefined(user) && user.units.length > 1 ? (
                              <button
                                className="menu-button"
                                type="button"
                                onClick={() => {
                                            dispatch(changeIsMainMenuOpened(false));
                                            dispatch(setPopupState(PopupState.UnitSelector));
                                        }}
                              >
                                {TranslationUtility.GetFormattedMessageForUI('ui-button-unit-selector',
                                    'Selección de Vivienda')}
                              </button>
                                ) : null}
                          </>
                        )}
          </div>
          <div className="menu-buttons-container">
            <button
              className="menu-button"
              type="button"
              onClick={() => {
                            saveConfigurationMutation.mutate();
                            dispatch(changeIsMainMenuOpened(false));
                            dispatch(saveConfiguration());
                        }}
            >
              {TranslationUtility.GetFormattedMessageForUI('ui-button-save-configuration', 'Guardar Configuración')}
            </button>
            <button
              className="menu-button"
              type="button"
              onClick={() => {
                            dispatch(changeIsMainMenuOpened(false));
                            dispatch(setPopupState(PopupState.LoadConfiguration));
                        }}
            >
              {TranslationUtility.GetFormattedMessageForUI('ui-button-load-configuration', 'Cargar Configuración')}
            </button>
          </div>
          {areTranslationsEnabled() ? (
            <div className="language-container">
              <button
                className="language-button"
                type="button"
                onClick={() => dispatch(changeLanguage(Language.es))}
                disabled={currentLanguage === Language.es}
              >
                Español
              </button>
              {isLanguageEnabled(Language.en) ? (
                <>
                  <div className="separator">-</div>
                  <button
                    className="language-button"
                    type="button"
                    onClick={() => dispatch(changeLanguage(Language.en))}
                    disabled={currentLanguage === Language.en}
                  >
                    English
                  </button>
                </>
                    ) : null}
              {isLanguageEnabled(Language.ca) ? (
                <>
                  <div className="separator">-</div>
                  <button
                    className="language-button"
                    type="button"
                    onClick={() => dispatch(changeLanguage(Language.ca))}
                    disabled={currentLanguage === Language.ca}
                  >
                    Català
                  </button>
                </>
                    ) : null}
            </div>
            ) : null}
        </div>
      </div>
    </div>
  );
};

export default MainMenu;
